import { atomField, required } from 'atoms/form-atoms';
import {
  GeologicIntervalQueryResponse,
  StructureGridQueryResponse,
} from 'types/api-responses';

export const structureGridCollectionForm = (owner?: string) => {
  return {
    basin: atomField<string>('', {
      validate: (v) => required(v, 'Basin is required'),
    }),
    collection: atomField<
      Map<GeologicIntervalQueryResponse, StructureGridQueryResponse>
    >(new Map<GeologicIntervalQueryResponse, StructureGridQueryResponse>(), {
      validate: (
        value: Map<GeologicIntervalQueryResponse, StructureGridQueryResponse>
      ) => {
        if (value.size === 0) {
          throw new Error('Assign Grids to Collection');
        }
        return value;
      },
    }),
    name: atomField<string>('', {
      validate: (v) => required(v, 'Name is required'),
    }),
    owner: atomField<string>(owner || '', {
      validate: (v) => required(v, 'Owner is required'),
    }),
    comment: atomField<string>(''),
  };
};

export const structureGridAssignmentForm = () => {
  return {
    draftCollection: atomField<
      Map<GeologicIntervalQueryResponse, StructureGridQueryResponse | null>
    >(new Map(), {
      validate: (
        value: Map<
          GeologicIntervalQueryResponse,
          StructureGridQueryResponse | null
        >
      ) => {
        if (value.size === 0) {
          throw new Error('Draft Collection is required');
        }
        return value;
      },
    }),
    proposedCollection: atomField<
      Map<GeologicIntervalQueryResponse, StructureGridQueryResponse>
    >(new Map(), {
      validate: (
        value: Map<GeologicIntervalQueryResponse, StructureGridQueryResponse>
      ) => {
        if (value.size === 0) {
          throw new Error('Proposed Collection is required');
        }
        return value;
      },
    }),
  };
};

export const getURLFilterParams = (params: URLSearchParams) => {
  return {
    basin: params.get('basin') ?? undefined,
    createdStart: params.get('created_start') ?? undefined,
    createdEnd: params.get('created_end') ?? undefined,
    isDefault: params.get('is_default') ?? undefined,
    landingAutoUpdateEnabled:
      params.get('landing_auto_update_enabled') ?? undefined,
    owner: params.get('owner') ?? undefined,
    status: params.get('status') ?? undefined,
    validity: params.get('validity') ?? undefined,
    dateFilterType: params.get('date_filter_type') ?? undefined,
    page: params.get('page') ?? undefined,
    pageSize: params.get('page_size') ?? undefined,
  };
};
